// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const banette: PokeData = {
  "id": 354,
  "name": "banette",
  "height": 11,
  "weight": 125,
  "base_experience": 159,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "night-shade",
    "screech",
    "curse",
    "spite",
    "feint-attack",
    "pain-split",
    "shadow-ball",
    "will-o-wisp",
    "trick",
    "role-play",
    "knock-off",
    "grudge",
    "snatch",
    "embargo",
    "sucker-punch",
    "shadow-sneak",
    "hex",
    "phantom-force"
  ],
  "moves": [
    "night-shade",
    "curse",
    "shadow-ball",
    "snatch",
    "shadow-sneak",
    "phantom-force",
    "shadow-dagger",
    "confuse-ray",
    "shadow-claws",
    "lick",
    "soul-sacrifice",
    "spectral-snatch",
    "poltergeist"
  ],
  "evolution_chain": {
    "id": 181,
    "item": null,
    "species": [
      {
        "name": "shuppet",
        "order": 381,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "banette",
        "order": 382,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 353,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 107,
    "ability_power": 189
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
